
/*
**	misc jquery plugins
*/

;(function($) {


$.fn.centerInWindow = function(opts) {
	opts = $.extend({
		dir: 'hv',
		childMetric: 'outer',
		style: 'fixed',
		animate: false
	}, opts);

	var fnwidChild = opts.childMetric == 'outer' || opts.childMetric == 'inner' ? opts.childMetric + 'Width' : 'width';
	var fnhgtChild = opts.childMetric == 'outer' || opts.childMetric == 'inner' ? opts.childMetric + 'Height' : 'height';

	return this.each(function() {
		var $this = $(this);
		$this.css('position', opts.style);

		if (/h/i.test(opts.dir)) {
			var childWid = opts.childWid || $this[fnwidChild]();
			var left;
			if (opts.style == 'fixed') {
				left = Math.floor(($(window).width()-childWid)/2);
			}
			else {
				left = Math.floor(($(window).width()-childWid)/2) + APP.Windows.docScrollLeft() + opts.topOffset;
			}
			if (opts.animate) {
                $this.animate({ left: left }, { queue: false, duration: opts.animate.duration, easing: 'swing' });
            } else {
                $this.css('left', left);
            }
		}
		if (/v/i.test(opts.dir)) {
			var childHgt = opts.childHgt || $this[fnhgtChild]();
			var top;
			if (opts.style == 'fixed') {
				top = Math.floor(($(window).height()-childHgt)/2);
			}
			else {
				top = Math.floor(($(window).height()-childHgt)/2) + APP.Windows.docScrollTop();
			}
            if (opts.animate) {
                $this.animate({ top: top }, { queue: false, duration: opts.animate.duration, easing: 'swing' });
            } else {
                $this.css('top', top);
            }
		}
	});
};

$.fn.centerInParent = function(opts) {
	var dflts = {
		dir: 'hv',
		childMetric: 'outer',	// 'inner', 'outer' or null which is used to determine which metric box is used for centering
		parentMetric: 'inner',	// 'inner' (centering includes padding) or null (=> center child within inner rect)
		technique: 'position'
	};
	opts = $.extend({}, dflts, opts || {});

	var fnwidParent = opts.parentMetric == 'inner' ? opts.parentMetric + 'Width' : 'width';
	var fnhgtParent = opts.parentMetric == 'outer' || opts.parentMetric == 'inner' ? opts.parentMetric + 'Height' : 'height';
	var fnwidChild = opts.childMetric == 'outer' || opts.childMetric == 'inner' ? opts.childMetric + 'Width' : 'width';
	var fnhgtChild = opts.childMetric == 'outer' || opts.childMetric == 'inner' ? opts.childMetric + 'Height' : 'height';

	return this.each(function() {
		var $this = $(this);
		var $parent = $this.parent();
        var extra;

		if (opts.technique == 'position') {
			switch ($parent.css('position')) {
				case 'relative':
				case 'absolute':
				case 'fixed':
					break;
				default:
					$parent.css('position', 'relative');
					break;
			}
			$this.css('position', 'absolute');
		}
		else if (opts.technique == 'float') {
			$this.css('float', 'left');
		}

		if (/h/i.test(opts.dir)) {
			var parentWid = opts.parentWid || $parent[fnwidParent]();
			var childWid = opts.childWid || $this[fnwidChild]();

			//APP.trace('center width: %d %d %d', $parent[fnwidParent](), $this[fnwidChild](), $this.width());
			if (opts.technique == 'position') {
				// abs positioning -> we have to be careful of catering for padding if we are
				// centering in the parent's innermost box, as abs elements have (0,0) in the
				// padding area (whereas floated elements don't)
				extra = 0;
				if (!opts.parentMetric) {
					extra = parseInt($parent.css('paddingLeft'));
				}
				$this.css('left', $P.sprintf('%dpx', (parentWid-childWid)/2 + extra));
			}
			else if (opts.technique == 'float' || opts.technique == 'margin') {
				$this.css('margin-left', $P.sprintf('%dpx', (parentWid-childWid)/2));
			}
		}
		if (/v/i.test(opts.dir)) {
			var parentHgt = opts.parentHgt || $parent[fnhgtParent]();
			var childHgt = opts.childHgt || $this[fnhgtChild]();

			//APP.trace('center height: %d %d %d', $parent[fnhgtParent](), $this[fnwidChild](), $this.height());
			if (opts.technique == 'position') {
				// abs positioning -> we have to be careful of catering for padding if we are
				// centering in the parent's innermost box, as abs elements have (0,0) in the
				// padding area (whereas floated elements don't)
				extra = 0;
				if (!opts.parentMetric) {
					extra = parseInt($parent.css('paddingTop'));
				}
				$this.css('top', $P.sprintf('%dpx', (parentHgt-childHgt)/2 + extra));
			}
			else if (opts.technique == 'float' || opts.technique == 'margin') {
				$this.css('margin-top', $P.sprintf('%dpx', (parentHgt-childHgt)/2));
			}
		}
	});
};


$.fn.opacity = function(val) {
	return typeof val === 'undefined' ?
		$(this).css('opacity') :
		this.each(function() {
			$(this).css('opacity', val);
		});
};



$.fn.isChecked = function() {
	try {
		return this[0].checked;
	}
	catch(e) {
		return false;
	}
};



$.fn.radioesque = function(opts) {
	opts = $.extend({
		cls: 'sel',
		$hidden: null,
		data: 'value',
		multiple: false,
		onoff: false,
		init: true,
		onClick: function($item) {}
	}, opts);

	var $items = this;

	if (opts.init && opts.$hidden) {
		$items.removeClass(opts.cls);
		if (opts.multiple) {
			$.each(JSON.parse(opts.$hidden.val() || '[]'), function(i, v) {
				$items.filter($P.sprintf('[data-value="%s"]', v)).addClass(opts.cls);
			});
		}
		else {
			$items.filter($P.sprintf('[data-%s="%s"]', opts.data, opts.$hidden.val())).addClass(opts.cls);
		}
	}

	return this.click(function() {
		var $this = $(this);
		if (opts.multiple) {
			$this.toggleClass(opts.cls);
			if (opts.$hidden) {
				var vals = [];
				$items.filter('.sel').each(function(i) {
					vals.push($(this).data(opts.data));
				});
				opts.$hidden.val(JSON.stringify(vals));
			}
		}
		else {
			if (opts.onoff && $this.is('.' + opts.cls)) {
				$this.toggleClass(opts.cls);
			}
			else {
				$items.removeClass(opts.cls).filter(this).addClass(opts.cls);
			}
			if (opts.$hidden) {
				opts.$hidden.val($this.is('.' + opts.cls) ? $this.data(opts.data) : '');
			}
		}
		opts.onClick($this);
	});
};



$.fn.enter = function(onEnter) {
	return this.keypress(function(event) {
		if (event.keyCode == 13) {
			return onEnter.apply(this);
		}
		return true;
	});
};



$.fn.flip = function(onEnter) {
	return this.mouseover(function() {
		var $this = $(this);
		$this.text($this.data('hover'));
	}).mouseout(function() {
		var $this = $(this);
		$this.text($this.data('text'));
	});
};


$.fn.disabled = function() {
	return this.prop('disabled', true);
};

$.fn.enabled = function() {
	return this.prop('disabled', false);
};

$.fn.visible = function() {
	return this.css('visibility', 'visible');
};

$.fn.invisible = function() {
	return this.css('visibility', 'hidden');
};

$.fn.scrollToEnd = function() {
	return this.each(function() {
		this.scrollTop = this.scrollHeight;
	});
};

$.fn.hoverSel = function(opts) {
	opts = $.extend({
		cls: 'sel',
		sel: ''
	}, opts || {});

	return this.mouseover(function() {
		if (opts.sel) {
			$(this).find(opts.sel).addClass(opts.cls);
		}
		else {
			$(this).addClass(opts.cls);
		}
	}).mouseout(function() {
		if (opts.sel) {
			$(this).find(opts.sel).removeClass(opts.cls);
		}
		else {
			$(this).removeClass(opts.cls);
		}
	});
};

$.fn.submitting = function(finished, submit_text_data) {
    if (!submit_text_data) {
        submit_text_data = 'submitText';
    }

	return this.each(function() {
        var $this = $(this);
        var fn = 'text';
        if (this.nodeName.toUpperCase() == 'INPUT') {
            fn = 'val';
        }

		if (finished) {
            $this[fn]($this.data('oldtext')).enabled();
        } else {
            $this
                .data('oldtext', $this[fn]())
                [fn]($this.data(submit_text_data))
                .disabled();
        }
	});
};


$.windowResize = function(opts) {
    if (typeof opts == "function") {
        opts = {
            onResize: opts
        };
    }
    opts = $.extend({
        delay: 500,
        trigger_now: true,
        onResize: function() {}
    }, opts || {});

    if (opts.trigger_now) {
        opts.onResize();
    }

    var timer_id;
    $(window).resize(function() {
        if (timer_id) {
            clearTimeout(timer_id);
            timer_id = null;
        }
        timer_id = setTimeout(opts.onResize, opts.delay);
    });
};


$.fn.fullOpacity = function() {
	return this.each(function() {
        var $this = $(this);
        if (parseInt($this.css('opacity')) === 0) {
            $this.css('opacity', 1);
        }
    });
};


$.fn.slideUpAndRemove = function(onDone) {
    return this.each(function() {
        var $this = $(this);
        $this.slideUp(function() {
            $(this).remove();
            if (onDone) {
                onDone();
            }
        });
    });
};


$.fn.siblingIdx = function() {
    var $siblings = this.parent().children();
    var node = this[0];
    var idx = -1;
    $siblings.each(function(i) {
        if (this == node) {
            idx = i;
            return false;
        }
    });
    return idx;
};


/**
 * hacked from https://gist.github.com/MattouFP/8359324
 */

$.smoothHash = function (params) {
    var scrollers = $('html, body');
    var opts = {
        marginTop: 0,
        speed: 500,
        easing: 'linear',
        set_hash: true,
        onBegin: function() {}
    };
    
    params = $.extend(opts, params);

    // animate scroll position to element
    function animateScroll(el, callback) {
        var scroll;
        if (typeof el === 'string') {
            el = $(el);
        }
        
        // find scroll position
        scroll = el.length ? el.offset().top - (typeof opts.marginTop === 'function' ? opts.marginTop() : opts.marginTop) : 0;
        
        scrollers.stop();
        scrollers.animate({
            scrollTop: scroll
        }, params.speed, params.easing, callback);
    }

    // runs animation before hash change, when link is clicked
    $(document).on('click', 'a[href*=#]', function (e) {
        var parser = document.createElement('a');
        var hash;

        parser.href = $(this).attr('href');
        hash = parser.hash;
        
        // if it links to a different page, don't animate
        if (window.location.protocol !== parser.protocol ||
                window.location.host !== parser.host ||
                window.location.pathname !== parser.pathname ||
                window.location.search !== parser.search) {
            return true;
        }
        
        e.preventDefault();
        opts.onBegin();
        animateScroll(hash, function() {
            if (opts.set_hash) {
                window.location.hash = hash;
            }
        });
    });

    return {
        animateScroll: animateScroll
    };
};



})(jQuery);


/* jslint multistr: true */

;(function($) {


////////////////////////////////////////////////////////////
// our main APP class


APP = (function() {
    var is_main_site;
    var is_admin_site;
    var navbar;
    var transformProperty;

    function getSupportedPropertyName(properties) {
        for (var i = 0; i < properties.length; i++) {
            if (typeof document.body.style[properties[i]] != "undefined") {
                return properties[i];
            }
        }
        return null;
    }


	$(document).ready(function() {

        /******
		// setup sniff attributes that we can only work out once js is loaded and going
		APP.sniff.touch = $('html').is('.touch');

		$('input[placeholder], textarea[placeholder]').inFieldLabels({ wrapperElem: 'div' });

		// desktop navbar
		new APP.NavBar({ navbar: '#navbar', sticky: true, activity: true });

		// mobile navbars
		new APP.NavBar({ navbar: '#mobile-main-navbar', sticky: false, activity: false });
		new APP.NavBar({ navbar: '#mobile-game-navbar', sticky: false, activity: true });
        **********/


		// fastclick - hmmmm, seems a bit broken on iphone 5s
        /***
		if (typeof FastClick !== "undefined") {
			FastClick.attach(document.body);
		}
        ***/


		// placeholder text
        if (APP.getURLParam('_bc') == 1) {
            APP.alert('body classes: %s', $('body').attr('class'));
        }

        // some general stuff
        var $body = $('body');
        is_main_site = $body.is('.main');
        is_admin_site = $body.is('.admin');

        // work out properties for this browser
        transformProperty = getSupportedPropertyName([ 'transform', 'msTransform', 'webkitTransform', 'mozTransform', 'oTransform' ]);

		// desktop navbar
		navbar = new APP.NavBar();

		// get body id, and use it to load a page manager function
		var id = $body.attr('id');
		if (id && /^page-/.test(id)) {
			var bits = id.split('-');
			var cls = '';
            var sep = '';
            var fn = APP;
			$.each(bits, function(i, v) {
				var seg = APP.capitalize(v);
                if (fn[seg]) {
                    fn = fn[seg];
                } else {
                    fn = false;
                    return false;
                }
			});

			if (fn && typeof fn === "function") {
				new fn();
			}
		}

        // some pages have managers based on body class...
        $.each([ 'product' ], function(idx, suffix) {
            if ($body.is('.template-' + suffix)) {
                var fn = 'Template' + suffix.titleize();
                if (typeof APP[fn] !== "undefined") {
                    new APP[fn]();
                }
            }
        });

        // "read more" links
        $('a.read-more').click(function() {
            var $this = $(this);
            $this.next().show().end().prev().hide().end().hide();
        });
	});


	////////////////////////////////////////////////////////////
	// blockUI defaults...

	// negate jQuery blockUI default styling (done in our own css)
	$.blockUI.defaults.css = {};
	$.blockUI.defaults.overlayCSS = {};

	// negate fadeIn/Out (makes the screen flicker too much, and too much work for mobiles)
	$.blockUI.defaults.fadeIn = 0;
	$.blockUI.defaults.fadeOut = 0;

	//TODO...
	$.extend($.blockUI.defaults.overlayCSS, {
		backgroundColor: '#000',
		opacity: 0.7,
		cursor: 'default'
	});
	$.blockUI.defaults.onLayersAppend = function(full) {
		if (full) {
			$('html, body > #everything').addClass('blocked');
			$('body > .blockOverlay').click(function() {
				$.unblockUI();
			});
		}
	};
	$.blockUI.defaults.onLayersDestroy = function(full) {
		if (full) {
			$('html, body > #everything').removeClass('blocked');
		}
	};





	return {

        showFullscreen: function() {
            $('html, body').addClass('covered');
        },

        hideFullscreen: function() {
            $('html, body').removeClass('covered');
        },

        getTransformProperty: function() {
            return transformProperty;
        },

        getNavbar: function() {
            return navbar;
        },

		argsAsArray: function(args) {
			return Array.prototype.slice.call(args);
		},

		alert: function() {
			window.alert($P.sprintf.apply(this, arguments));
		},

		confirm: function() {
			return window.confirm($P.sprintf.apply(this, arguments));
		},

		trace: function() {
			if (typeof console == 'undefined' || !console.log) {
				return;
			}
			console.log($P.sprintf.apply(this, arguments));
		},

		dir: function(obj, leadin) {
			if (typeof console == 'undefined' || !console.log || !console.dir) {
				return;
			}
			if (leadin) {
				console.log(leadin);
			}
			console.dir(obj);
		},

		is: {
			bool: function (obj) {
				return typeof obj === "boolean";
			},
			def: function (obj) {
				return typeof obj !== "undefined";
			},
			number: function (obj) {
				return typeof obj === "number" && isFinite(obj);
			},
			fn: function (obj) {
				return typeof obj === "function";
			},
			array: function (obj) {
				return obj ? this.number(obj.length) && this.fn(obj.splice) : false;
			},
			string: function (obj) {
				return typeof obj === "string";
			},
			object: function (obj) {
				return (obj && (typeof obj === "object" || this.fn(obj))) || false;
			}
		},

		reload: function() {
			var href = window.location.href;
			if (window.location.hash) {
				// we have to add a rand GET param to poison the current url to force reload
				href = APP.Url.Builder(window.location.href, {
					addQueryParams: {
						//_redrnd: Math.floor(Math.random() * 10)
						_redrnd: (new Date()).getTime()
					}
				}).build();
			}
			window.location.replace(href);
		},

        // shortcuts to htmlspecialchars and htmlentities
        // (saves typing!)
        hsc: function() {
			var args = APP.argsAsArray(arguments);
			return $P.htmlspecialchars(args.length == 1 ? (args[0] || '') : $P.sprintf.apply(null, args));
        },
        
        hscdec: function(s) {
			return $P.htmlspecialchars_decode(s);
        },
        
        he: function() {
			var args = APP.argsAsArray(arguments);
			return $P.htmlentities(args.length == 1 ? (args[0] || '') : $P.sprintf.apply(null, args), 'ENT_QUOTES');
        },

        NON_CHAR_KEY_CODES: [8, 9, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 91, 92, 93],
        isNonCharKeyCode: function(e) {
            return $.inArray(e.keyCode, this.NON_CHAR_KEY_CODES) != -1 || ((e.ctrlKey || e.metaKey) && $.inArray(e.keyCode, [67, 88]) != -1);
        },

        KeyCodes: {
            SPACE: 32,
            ESC: 27,
            RETURN: 13,
            BACKSPACE: 8,
            TAB: 9,
            SHIFT: 16,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            HOME: 36,
            END: 35
        },

		capitalize: function(input) {
		    return input.replace(/^./, function (match) {
				return match.toUpperCase();
			});
		},


		getThisUrl: function() {
			return new APP.Url.Builder(document.location.toString());
		},

		getURLParam: function(name) {
			return this.getThisUrl().getQueryParam(name);
		},

        updateHash: function(hash) {
            if (history.pushState) {
                if (hash) {
                    history.pushState(null, null, '#' + hash);
                } else {
                    history.pushState('', document.title, window.location.pathname);
                }
            } else {
                location.hash = hash;
            }
        },

        canUpdateHash: function() {
            return !!history.pushState;
        },

        checkDesktop: function(min_wid) {
            return $(window).width() >= (min_wid || 768);
        },

        checkMobile: function(max_wid) {
            return $(window).width() < (max_wid || 768);
        },

        checkDesktopOrMobileCls: function(min_wid) {
            return this.checkDesktop(min_wid) ? '.desktop' : '.mobile';
        }

	};

})();


/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */

// a handy place to stash page-specific stuff
APP.ThisPage = {};

// specific page manager classes are in separate files, but all go in APP.Page.*
APP.Page = {};


})(jQuery);



/* jslint multistr: true */

;(function($) {



/**
 * navbar
 */

APP.NavBar = function(opts) {
    var mobileNavBar = function() {
        var $navbar = $('#nav.mobile');
        //$navbar.find('.menu-actions .hamburger, .menu-actions .cross').click(function() {
        $navbar.find('.menu-actions').click(function() {
            $navbar.toggleClass('open');
        });
    };

    var desktopNavBar = function() {
        $navbar = $('#nav.desktop');
        var $ctr_full = $navbar.find('.ctr.full');
        if ($ctr_full.length === 0) {
            // page just has trimmed navbar
            return;
        }

        var full_hgt = $ctr_full.outerHeight(true);
        var $ctr_trim = $navbar.find('.ctr.trim');
        var $wrapper = $ctr_trim.find('.wrapper');
        var trim_hgt = $wrapper.outerHeight(true);

        var controller = new ScrollMagic.Controller();

        var scene = new ScrollMagic.Scene({ triggerElement: $ctr_full, triggerHook: 'onLeave', offset: full_hgt-trim_hgt, duration: $(document).height() })
            .addTo(controller)
            .on('enter', function(e) {
                //APP.trace('animation enter');
                $navbar.addClass('contracted');
            })
            .on('leave', function(e) {
                //APP.trace('animation leave');
                $navbar.removeClass('contracted');
            });
    };

    mobileNavBar();
    desktopNavBar();
};



})(jQuery);



/* jslint multistr: true */

;(function($) {


////////////////////////////////////////////////////////////
// our main APP class


APP.TemplateProduct = (function() {
    var $prodimgs = $('#product-images');
    var $imgs = $prodimgs.find('> img');
    var $prodthumbs = $('#product-thumbs');
    var multiple = $prodimgs.is('.multiple');

    $prodthumbs.find('li a').click(function() {
        var $this = $(this);
        var idx = $this.closest('li').index();
        $imgs.removeClass('active').filter(':eq(' + idx + ')').addClass('active');
        return false;
    });

    var load_info = [];
    $imgs.load(function(e) {
        var $this = $(this);
        APP.trace('loaded %s', $this.src);
        addImg(this);
    }).click(function() {
        if (multiple) {
            nextImage(this);
        }
    });

    $imgs.each(function(i) {
        if (this.complete) {
            APP.trace('adding already loaded image %s', this.src);
            addImg(this);
        }
    });

    function addImg(img) {
        if (img.width === 0 || img.height === 0) {
            return;
        }
        load_info.push({ w: img.width, h: img.height });
        APP.dir(load_info);
        if (load_info.length === $imgs.length) {
            fitImages();
        }
    }

    function fitImages() {
        if (!multiple) {
            return;
        }
        //debugger;
        var maxh = -1;
        var parent_wid = $prodimgs.width();
        for (var i = 0; i < load_info.length; i++) {
            var h = parent_wid / (load_info[i].w / load_info[i].h);
            if (h > maxh) {
                maxh = h;
            }
        }
        $prodimgs.height(maxh);
    }

    function nextImage(img) {
        var $img = $(img);
        var curr_idx = $img.index();
        var next_idx = (curr_idx+1) % $prodthumbs.find('img').length;
        $imgs.removeClass('active').filter(':eq(' + next_idx + ')').addClass('active');
    }


    // this hook is called from the theme.js.liquid module
    window.checkProductAddToCart = function() {
        var $loc = $('#bee-check-location');
        var $temp = $('#bee-check-temp');
        var $wait = $('#bee-check-wait');

        // if ($loc.length && (!$loc[0].checked || !$temp[0].checked || !$wait[0].checked)) {
        if (($loc.length && !$loc[0].checked) || ($temp.length && !$temp[0].checked) || ($wait.length && !$wait[0].checked)) {
            APP.alert('Please sign off on all the Live Bee Check conditions!');
            return false;
        }

        return true;
    };
});

})(jQuery);


/* jslint multistr: true */

;(function($) {



/*
** a handy url parser/builder
*/

APP.Url = {};

APP.Url.Builder = function(url, cmds) {

	var origurl;
	var parsed;

	var _inst = {
		_set: _set,
		dump: dump,
		clone: clone,
		parse: parse,
		apply: apply,
		clean: clean,
		build: build,
		addQueryParams: addQueryParams,
		removeQueryParams: removeQueryParams,
		removeAllQueryParams: removeAllQueryParams,
		addOrRemoveQueryParams: addOrRemoveQueryParams,
		removeFragment: removeFragment,
		getQueryParam: getQueryParam,
		getFragment: getFragment
	};

	_construct(url, cmds);

	return _inst;



	////////////////////////////////////////////////////////////////////////////////
	// general methods

	function _construct(url, cmds) {
		parse(url);
		apply(cmds);
	}

	function _set(_origurl, _parsed) {
		origurl = _origurl;
		parsed = $.extend(true, {}, _parsed);
		return _inst;
	}

	function dump() {
		APP.trace('origurl: %s', origurl);
		APP.dir(parsed, 'parsed:');
		return _inst;
	}

	function clone() {
		return new APP.Url.Builder()._set(origurl, parsed, parsed.queryArgs);
	}

	function parse(url) {
		origurl = url;

		if (!url) {
			return _inst;
		}

		// do a basic parse
		parsed = $P.parse_url(url || window.location);

		// split off args from the basic string we now have
		parsed.queryArgs = {};
		if (parsed.query) {
			$.each(parsed.query.split('&'), function(i, v) {
				var bits = v.split('=');
				if (bits && bits.length == 2) {
					parsed.queryArgs[bits[0]] = $P.urldecode(bits[1]);
				}
			});
		}

		return _inst;
	}

	function apply(cmds) {
		if (!cmds) {
			return _inst;
		}

		if (cmds.clean) {
			clean();
		}
		if (cmds.addQueryParams) {
			addQueryParams(cmds.addQueryParams);
		}
		if (cmds.removeQueryParams) {
			removeQueryParams(cmds.removeQueryParams);
		}
		if (cmds.removeAllQueryParams) {
			removeAllQueryParams();
		}

		return _inst;
	}

	function clean() {
		//return removeQueryParams(APP.ThisPage.urls.superfluousQueryParams);
	}

	function build(opts) {
		opts = $.extend({
			queryParamSep: '&',
			paramsDontEncode: []
		}, opts);

		var url = $P.sprintf(
			'%s%s',
			parsed.host ?
				$P.sprintf('%s://%s%s',
					parsed.scheme,
					parsed.user ? $P.sprintf('%s:%s@', parsed.user, parsed.pass) : '',
					parsed.host || APP.domain
				) : (APP.home || ''),
			parsed.path
		);

		var sep = '?';
		for (var nm in parsed.queryArgs) {
			url += sep + $P.sprintf('%s=%s', nm, $P.in_array(nm, opts.paramsDontEncode) ? parsed.queryArgs[nm] : $P.urlencode(parsed.queryArgs[nm]));
			sep = opts.queryParamSep;
		}

		if (parsed.fragment) {
			url += '#' + parsed.fragment;
		}

		return url;
	}

	function addQueryParams(argOrArray) {
		var args = APP.argsAsArray(arguments);
		for (var i=0; i<args.length; ) {
			if (APP.is.string(args[i])) {
				if (args[i]) {
					parsed.queryArgs[args[i]] = args[i+1];
				}
				i += 2;
			}
			else if (APP.is.array(args[i]) || APP.is.object(args[i])) {
				for (var nm in args[i]) {
					if (args[i][nm]) {
						parsed.queryArgs[nm] = args[i][nm];
					}
				}
				i++;
			}
		}
		return _inst;
	}

	function removeQueryParams(argOrArray) {
		var args = APP.argsAsArray(arguments);
		for (var i=0; i<args.length; i++) {
			if (APP.is.string(args[i])) {
				delete parsed.queryArgs[args[i]];
			}
			else if (APP.is.array(args[i]) || APP.is.object(args[i])) {
				for (var nm in args[i]) {
					delete parsed.queryArgs[nm];
				}
			}
		}
		return _inst;
	}

	function removeAllQueryParams() {
		parsed.queryArgs = {};
		return _inst;
	}

	function addOrRemoveQueryParams(cond1, key1, value1) {
		var args = APP.argsAsArray(arguments);
		for (var i=0; i<args.length; i+=3) {
			var cond = args[i];
			var key = args[i+1];
			var value = args[i+2];
			if (cond) {
				parsed.queryArgs[key] = value;
			}
			else {
				delete parsed.queryArgs[key];
			}
		}
		return _inst;
	}

	function removeFragment() {
		parsed.fragment = null;
		return _inst;
	}


	////////////////////////////////////////////////////////////////////////////////
	// getters

	function getQueryParam(which) {
		return which ? parsed.queryArgs[which] : false;
	}

	function getFragment() {
		return parsed.fragment;
	}



};





})(jQuery);

